
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.11 10.71c.13.22.25.44.37.67C41.35 24 32.65 33.12 28 35.64c-5.06 2.75-13.79 4.77-16.77-.71s3.38-7.85 1.32-11.64-7.5.25-10.48-5.23S5.55 6.35 10.61 3.61C14.77 1.34 25.16-.78 32.21 8","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"10.68","cy":"13.52","r":"2.63","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"20.83","cy":"10.32","r":"2.63","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M24.89 28.4a3.83 3.83 0 002.33.77 3.9 3.9 0 001.5-7.49M24.61 26.72s.71 1.93-1.26 4.49c-2.3 3-7.13 2.6-7.13 2.6a5.09 5.09 0 001.05-3.28 5.92 5.92 0 01.8-4.86A4.28 4.28 0 0121 23.83","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M20.61 23.79S33.27 6.27 36.17 2.8a1.51 1.51 0 012-.48 1.5 1.5 0 01.28 2c-2.15 4-13.31 22.52-13.31 22.52z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    